import { DEFERRED_REDIRECT_SESSION_ITEM, LAST_VISIT_HREF_SESSION_ITEM, } from '@assetmark/ewm30-routing-shell';
export const getOnSigninCallback = (useDefferedOidcRedirect) => {
    return (user) => {
        let href = null;
        /**
         * Try to get href from the state object after round-trip to authentication.
         */
        if (user &&
            user.state &&
            typeof user.state === 'object' &&
            'href' in user.state) {
            href = user.state.href;
        }
        /**
         * Try to get last visit href from the sessionStorage.
         */
        if (!href && window.sessionStorage) {
            href = window.sessionStorage.getItem(LAST_VISIT_HREF_SESSION_ITEM);
        }
        if (useDefferedOidcRedirect && window.sessionStorage) {
            /** We can defer the last redirect until the routing is ready,
             * and handle that by the routing shell so that we don't reload the page.
             */
            window.sessionStorage.setItem(DEFERRED_REDIRECT_SESSION_ITEM, href ?? 'true');
        }
        else {
            /**
             * This causes three redirects. It's a "Plan B" for the case when
             * the routing shell is not available/enabled.
             */
            window.location.replace(href ?? window.location.pathname);
        }
    };
};
